import React, { useEffect, useState } from "react";
import PlayerMatches from "./PlayerMatches";
import News from "../../common/News";
import NoDataFound from "../../common/NoDataFound";
import { loadStyles } from "../../../utils/cssLoader";

const PlayerInfo = ({
  ServerData,
  loadCSS = true,
  dataClient = false,
  title,
  dictionary = {},
  showNews = false,
  newsData,
  baseUrl,
  sport = "football",
  playerId,
}) => {
  const [clientData, setClientData] = useState(null);
  const data = dataClient ? clientData : ServerData || [];

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("footballplayer");
    }
  }, [loadCSS]);

  // Build player fields array for two-column layout
  const buildPlayerFields = () => {
    const fields = [];

    if (data?.player?.nm) {
      fields.push({ label: "Team", value: data.player.nm });
    }
    if (data?.player?.shirt_no) {
      fields.push({ label: "Shirt Number", value: data.player.shirt_no });
    }
    if (data?.player?.foot) {
      fields.push({ label: "Preferred Foot", value: data.player.foot });
    }
    if (data?.player?.position) {
      fields.push({ label: "Position", value: data.player.position });
    }
    if (data?.player?.residence) {
      fields.push({ label: "Citizenship", value: data.player.residence });
    }
    if (data?.player?.market) {
      fields.push({ label: "Market Value", value: data.player.market });
    }
    if (data?.player?.dob) {
      fields.push({ label: "Date of Birth", value: data.player.dob });
    }
    if (data?.player?.height) {
      fields.push({ label: "Height", value: data.player.height });
    }
    if (data?.player?.weight) {
      fields.push({ label: "Weight", value: data.player.weight });
    }

    return fields;
  };

  // Render two-column table rows (like bole-saas)
  const renderPlayerInfoRows = () => {
    const fields = buildPlayerFields();
    const rows = [];

    for (let i = 0; i < fields.length; i += 2) {
      rows.push(
        <tr key={i}>
          <td>{fields[i].label}:</td>
          <td>{fields[i].value}</td>
          {fields[i + 1] ? (
            <>
              <td>{fields[i + 1].label}:</td>
              <td>{fields[i + 1].value}</td>
            </>
          ) : (
            <>
              <td></td>
              <td></td>
            </>
          )}
        </tr>
      );
    }

    return rows;
  };

  const hasPlayerData = data?.player && Object.keys(data.player).length > 0;
  const hasPerformanceData = data?.player_performance?.length > 0;

  if (!hasPlayerData && !hasPerformanceData) {
    return (
      <div className="player_info">
        {title && <h1>{title}</h1>}
        <NoDataFound text="No player information available" />
      </div>
    );
  }

  return (
    <div className="player_info">
      {title && <h1>{title}</h1>}

      {hasPlayerData && (
        <div className="info_block">
          <div className="leg_head">
            <h2>{dictionary?.playerInformation || "Player Information"}</h2>
          </div>

          <div className="global_table player_info_tbl">
            <table>
              <tbody>{renderPlayerInfoRows()}</tbody>
            </table>
          </div>
        </div>
      )}

      {hasPerformanceData && (
        <div className="info_block">
          <div className="leg_head">
            <h2>{dictionary?.lastMatches || "Last 6 Matches"}</h2>
          </div>

          <PlayerMatches data={data.player_performance} />
        </div>
      )}

      {/* Integrated News Section (optional) */}
      {showNews && newsData?.length > 0 && (
        <div className="info_block">
          <div className="leg_head">
            <h2>{dictionary?.relatedNews || "Related News"}</h2>
          </div>

          <News
            data={newsData}
            id={playerId}
            newsType="player"
            sport={sport}
            baseUrl={baseUrl}
            limit={3}
          />
        </div>
      )}
    </div>
  );
};

export default PlayerInfo;
